import styled from "styled-components";

export const SSelectFromTemplateStepTemplatesGrid = styled.div`
  padding: 40px 120px;
  box-sizing: border-box;
`;
